var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-user-list',{attrs:{"users":_vm.users,"columns":['name', 'phone', 'email'],"headers":{
    accountName: () => _vm.$t('global.venue'),
  }},on:{"addUser":_vm.onAddUser,"userClick":_vm.onUserClick,"removeUser":_vm.onRemoveUser}},[_c('ez-user-modal',{ref:"userModal",attrs:{"formKey":_vm.formKey,"formAction":_vm.formAction,"additionalData":{ roleKey: 'distributor_subscriber' },"user":_vm.selectedUser,"shouldMirror":true},on:{"close":_vm.onCloseModal,"success":_vm.onSubmitSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }